import { render, staticRenderFns } from "./SettingsPatientUsers.vue?vue&type=template&id=549468e6"
import script from "./SettingsPatientUsers.vue?vue&type=script&lang=js"
export * from "./SettingsPatientUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports